import PointModal from "../pointModal";

window.addEventListener('DOMContentLoaded', () => {
    let points = document.querySelectorAll('.js-point');
    if (points.length > 0) {
        points.forEach(point => {
            new PointModal(point);
        });
    }

    const image = document.querySelector('.action-map__image');
    const image_container = document.querySelector('.action-map');

    const container_width = image_container.offsetWidth;
    const image_width = image.offsetWidth;
    const scroll_amount = 2;
    let currentPos = 0;
    let direction = 1;
    let scroll_count = 0;
    const max_scrolls = 3;

    function scrollImage() {
        currentPos += direction * scroll_amount;

        if(currentPos > container_width - image_width || currentPos < 0) {
            direction *= -1;
            scroll_count++;

            if(scroll_count >= max_scrolls * 2) {
                return;
            }
        }

        image.style.transform = `translateX(${currentPos}px)`;
        requestAnimationFrame(scrollImage);
    }

    scrollImage()
});

